<template>
  <div class="main">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"> <router-link to="/console">创作者中心</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ this.$t('lang.title.post') }}</li>
      </ol>
    </nav>
    <div class="row g-5">
      <div class="col-md-12">
        <ul class="nav flex-row ">
          <li class="nav-item"><span class="nav-link nav-title p-1 text-muted ">{{ this.$t('lang.dict.category')
              }}</span></li>
          <li class="nav-item" v-for="item in menulist" :key="item.id">
            <a class="nav-link p-1 text-muted "
              :class="[item.id === $store.state.searchOpt.category ? 'selectedLink' : '']"
              v-on:click="changeCategory(item.id)" exact>{{
          item.title }}</a>
          </li>
        </ul>
        <ul class="nav flex-row ">
          <li class="nav-item"><span class="nav-link nav-title p-1 text-muted ">{{ this.$t('lang.dict.status') }}</span>
          </li>
          <li class="nav-item" v-for="opt in statusOpt" :key="opt.val">
            <a class="nav-link p-1 text-muted "
              :class="[opt.val === $store.state.searchOpt.status ? 'selectedLink' : '']"
              v-on:click="changeStatus(opt.val)" exact>{{
          opt.text }}</a>
          </li>
        </ul>
        <button id="btnAdd" type="button" class="btn btn-sm btn-outline-info" v-on:click="createDetails()">
          <i class="fa fa-plus"></i> {{ this.$t('lang.toolbar.Add') }}
        </button>
        <div v-for="item in docIndex" :key="item.id">
          <ul class="list-unstyled">
            <li class="media alert alert-light" v-for="menuitem in item.menuitems" :key="menuitem.id">
              <div class="media-body">
                <h6 class="mt-0 mb-1 text-body">{{ menuitem.title }}
                  <span class="btn  btn-outline-info pull-right" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false"><i class="fa fa-ellipsis-v"></i>
                  </span>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><button class="dropdown-item link-dark" type="button" v-on:click="toDetails(menuitem.id)"><i
                          class="fa fa-pencil"></i>
                        编辑</button></li>
                    <li><button class="dropdown-item link-dark" type="button" v-on:click="genarate(menuitem.id)"><i
                          class="fa fa-file"></i>
                        图文生成</button></li>
                    <li><button class="dropdown-item link-secondary mt-1" type="button"
                        v-on:click="onDelete(menuitem.id, menuitem.status)"><i class="fa fa-trash"></i> 删除</button></li>
                  </ul>
                </h6>
                <small class="text-secondary" v-html="menuitem.tags"></small>
                <h6 class="mt-0 mb-1 subtitle"><small>{{ menuitem.dt }}</small><br><small>{{ menuitem.dt2 }}</small><br>
                  <small v-if="menuitem.subtitle">{{ menuitem.subtitle }}&nbsp;</small>
                </h6>
              </div>
            </li>
          </ul>
        </div>
        <div class="media alert alert-light  text-center">
          --- the end ---
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal } from 'bootstrap'
import sx from "../../utils/core.js";
// Import jquery
import $ from 'jquery'

// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  data() {
    return {
      tags: '',
      doc: {},
      gallery: [],
      meta: {},
      searchOpt: {
        kbn: '00',
        status: '1',
        category: '',
        creator: ''
      },
      statusOpt: [
        { text: sx.getcate('0', "DefStatus", this.$i18n.locale), val: '0' },
        { text: sx.getcate('1', "DefStatus", this.$i18n.locale), val: '1' },
        { text: sx.getcate('2', "DefStatus", this.$i18n.locale), val: '2' },
        { text: sx.getcate('9', "DefStatus", this.$i18n.locale), val: '9' }
      ],
      menulist: [{ title: "产品文档", id: "14" }, { title: "营销文案", id: "15" }, { title: "解决方案", id: "16" }, { title: "学习笔记", id: "17" }, { title: "攻略指南", id: "18" }, { title: "归纳总结", id: "24" }],
      docIndex: []
    };
  },
  watch: {
  },
  mounted() {
    const that = this;
    that.$store.state.confirmdef2 = {
      title: that.$t('lang.toolbar.Confirm'),
      msg: that.$t('lang.msg.toDelete'),
      event: 'PostDelete'
    }
    that.onSearch();
  },
  methods: {
    changeCategory(category) {
      const that = this
      that.$store.state.searchOpt.category = category;
      that.onSearch();
    },
    changeStatus(status) {
      const that = this
      that.$store.state.searchOpt.status = status;
      that.onSearch();
    },
    onDelete(postid, status) {
      const that = this
      const myconfirmModal = new Modal(document.querySelector("#myModalConfirm2"));
      myconfirmModal.show();
      $("#confirm2").click(function () {
        myconfirmModal.hide();
        if (that.$store.state.confirmdef2.event != "PostDelete") {
          return
        }
        sx.toastInfo(status);
        if (status !== "0") {
          sx.toastError(that.$t('lang.error.notAllowed', { str: sx.getcate(status, "DefStatus", that.$i18n.locale) }));
          return;
        }
        var params = {
          id: postid,
          token: localStorage.getItem("token")
        };
        var url = that.$store.state.baseurl + '/app/cmshelper/deletePost'
        sx.request(
          url,
          params,
          function (result) {
            if (result.status === "ok") {
              sx.toastSuccess(that.$t('lang.info.succeedDelete'));
              that.onSearch();
            } else {
              sx.toastError("请求失败:" + result.message);
            }
          },
          function (result) {
            console.log(result)
          }
        )
      });
    },
    createDetails() {
      this.$router.replace({ name: 'PostGeneral', query: { mode: "create" } })
    },
    toDetails(id) {
      localStorage.setItem('postinfo.id', id);
      this.$router.replace({ name: 'PostGeneral' })
    },
    genarate(id) {
      const that = this
      var params = {
        token: localStorage.getItem("token"),
        bucketid: '13',
        id: id
      };
      var url = that.$store.state.baseurl + '/app/txthelper/genaratePromote'
      const mymodal = sx.showWaiting()
      sx.request(
        url,
        params,
        function (result) {
          if (result.status === "ok") {
            sx.toastSuccess(result.message);
          } else {
            sx.toastError("request error:" + result.message);
          }
          sx.hideWaiting(mymodal)
        },
        function (result) {
          console.log(result)
          sx.hideWaiting(mymodal)
        }
      )
    },
    onSearch() {
      const that = this;
      const mymodal = sx.showWaiting()
      that.searchOpt = that.$store.state.searchOpt
      that.searchOpt.creator = that.$store.state.userinfo.username
      var params = {
        bucketid: '13',
        options: JSON.stringify(that.searchOpt),
        token: localStorage.getItem("token") || "token"
      };
      var url = that.$store.state.baseurl + '/app/cmshelper/fetchPostList'
      sx.request(
        url,
        params,
        function (result) {
          if (result.status === 'ok') {
            that.docIndex = []
            var items = result.data.rows
            var menuitems = []
            $.each(items, function (idx, item) {
              var menuurl = require("../../assets/img_3.jpg")
              var meta = JSON.parse(item[10] || "{}")
              if (meta.gallery && meta.gallery.length > 0) {
                menuurl = 'https://cloud.salesmini.cn' + meta.gallery[0]
              }
              menuitems.push({
                id: item[0],
                title: item[1],
                subtitle: item[4],
                status: item[8],
                dt2: item[9],
                dt: item[12],
                tags: sx.gethtmltags(item[3]),
                preface: item[5],
                preface2: sx.substring(item[5], 100, "..."),
                url: menuurl
              })
            });
            that.docIndex.push({
              id: 0,
              menuitems: menuitems
            })
            sx.hideWaiting(mymodal)
          } else {
            that.docIndex = []
            sx.toastSuccess(result.message)
            console.log(result.message)
            sx.hideWaiting(mymodal)
          }
        },
        function () {
          sx.login(
            url,
            params,
            function (result) {
              if (result.status === 'ok') {
                that.docIndex = []
                var items = result.data.rows
                var menuitems = []
                $.each(items, function (idx, item) {
                  var menuurl = require("../../assets/img_3.jpg")
                  var meta = JSON.parse(item[10] || "{}")
                  if (meta.gallery && meta.gallery.length > 0) {
                    menuurl = 'https://cloud.salesmini.cn' + meta.gallery[0]
                  }
                  menuitems.push({
                    id: item[14],
                    title: item[1],
                    subtitle: item[4],
                    dt: item[12],
                    tags: sx.gethtmltags(item[3]),
                    preface: item[5],
                    preface2: sx.substring(item[5], 100, "..."),
                    url: menuurl
                  })
                });
                that.docIndex.push({
                  id: 0,
                  menuitems: menuitems
                })
                sx.hideWaiting(mymodal)
              } else {
                that.docIndex = []
                sx.toastError(that.$t('lang.error.failedRequest', { err: result.message }));
              }
            }
          )
        }
      )
      sx.hideWaiting()
    }
  }
}
</script>
<style>
#btnAdd {
  margin-bottom: 8px
}

.custom-tag {
  background-color: #E8E8E8;
  padding: 2px 4px 2px 4px;
  border-radius: 2px;
}

.subtitle {
  color: #909399
}

.selectedLink {
  font-size: large;
  font-weight: bold;
  color: #0dcaf0 !important;
}

.nav-link {
  cursor: pointer;
}

.nav-title {
  color: darkcyan !important;
}

.media {
  margin-bottom: 8px;
  background-color: #f6f6f6;
  padding: 8px;
  border-radius: 4px;
}
</style>
